import { styled } from "@mui/material";
import { DRAWER_WIDTH_IN_PX } from "../../../components/RecommendationsDrawer/utils";

export const TopRightPane = styled("div")({
	marginLeft: "auto",
	gap: "2px",
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	marginRight: "10px",
});

export const MainContainer = styled("div")<{ drawerOpen: boolean }>(({ drawerOpen }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	px: 2,
	py: 1,
	bgcolor: "white",
	boxShadow: "0px 4px 8px 0px rgba(107, 104, 153, 0.15)",
	zIndex: 2,
	height: "78px",
	marginRight: drawerOpen ? `${DRAWER_WIDTH_IN_PX}px` : 0,
	transition: "background 0.3s ease",
}));

export const MainStatsBarContainer = styled("div")<{ drawerOpen: boolean; expanded: boolean }>(({ drawerOpen, expanded }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	px: 2,
	background: "white",
	position: "relative",
	zIndex: 1,
	boxShadow: expanded ? "none" : "0px 4px 8px 0px rgba(107, 104, 153, 0.15)",
	marginRight: drawerOpen ? `${DRAWER_WIDTH_IN_PX}px` : 0,
	borderBottom: expanded ? "1px solid #e0e0e0" : "none",
}));
